"use client";

import Search from "@/assets/svg/24/Search";

import styles from "../header.module.css";
import useSearchModal from "../useSearchModal";

const SearchModalTrigger = () => {
  const { toggleModal } = useSearchModal();

  return (
    <button className={`${styles.icon} ${styles.search}`} onClick={toggleModal}>
      <Search />
    </button>
  );
};

export default SearchModalTrigger;
